import { useState } from "react";
import { api } from "@/admin/api";
import { useAuth } from "@/admin/AdminApp";
import { Btn, Card, ErrorMsg, Field, inputCls } from "@/admin/ui";

export default function SettingsPage() {
  const { user, logout } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [msg, setMsg] = useState(null);
  const [error, setError] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setMsg(null);
    setError(null);
    if (f.next.length < 10) return setError("New password must be at least 10 characters");
    if (f.next !== f.confirm) return setError("New passwords do not match");
    try {
      await api("/auth/change-password", { method: "POST", body: { current_password: f.current, new_password: f.next } });
      setF({ current: "", next: "", confirm: "" });
      setMsg("Password changed. Use the new one next time you log in.");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div data-testid="settings-page" className="space-y-5">
      <h1 className="text-2xl font-bold text-navy md:text-3xl">Settings</h1>
      <Card>
        <p className="text-sm text-body">Signed in as</p>
        <p data-testid="settings-email" className="font-semibold text-navy">{user.email}</p>
        <Btn variant="outline" onClick={logout} data-testid="settings-logout" className="mt-4 w-full sm:w-auto">Log out</Btn>
      </Card>
      <Card>
        <h2 className="mb-4 text-lg font-bold text-navy">Change password</h2>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Current password"><input data-testid="pw-current" type="password" autoComplete="current-password" required value={f.current} onChange={set("current")} className={inputCls} /></Field>
          <Field label="New password (10+ characters)"><input data-testid="pw-new" type="password" autoComplete="new-password" required value={f.next} onChange={set("next")} className={inputCls} /></Field>
          <Field label="Confirm new password"><input data-testid="pw-confirm" type="password" autoComplete="new-password" required value={f.confirm} onChange={set("confirm")} className={inputCls} /></Field>
          <ErrorMsg error={error} />
          {msg && <p data-testid="pw-success" className="rounded-xl bg-emerald-50 px-4 py-3 text-sm font-medium text-emerald-800">{msg}</p>}
          <Btn type="submit" data-testid="pw-save" className="w-full sm:w-auto">Change password</Btn>
        </form>
      </Card>
    </div>
  );
}
